module.exports = __webpack_public_path__ + "static/media/ipl-banner.3863bbed.webp";